export const DEFAULT_THEME = "dark";
export const THEME_STORAGE_KEY = "exordos-theme";
export const SUPPORTED_THEMES = ["light", "dark"] as const;

export type AppTheme = (typeof SUPPORTED_THEMES)[number];

export function isAppTheme(value: unknown): value is AppTheme {
  return SUPPORTED_THEMES.includes(value as AppTheme);
}

export function getNextTheme(theme: AppTheme): AppTheme {
  return theme === "light" ? "dark" : "light";
}
